import React from 'react'

import styled from '@emotion/styled'
import { mq } from '../../../_style';

const Container = styled.section`
  padding-top: 86px;
  padding-bottom: 60px;
  ${mq.pc} {
    display: flex;
  }
  h3 {
    margin-bottom: 50px;
    font-size: 26px;
    line-height: 1;
    letter-spacing: 0.4em;
    white-space: nowrap;
    ${mq.pc} {
      margin-right: calc(94 / 960 * 100%);
    }
    ${mq.sp} {
      margin-bottom: 45px;
    }
  }
`
const Inner = styled.div``
export default class DetailFeature extends React.Component {
  render() {
    return(
      <Container>
        <h3>特長</h3>
        <Inner>
          {this.props.children}
        </Inner>
      </Container>
    )
  }
}
